(function () {
  'use strict';

  var MAX_FILE_BYTES = 20 * 1024 * 1024;
  var UPLOAD_ENDPOINT = '/apps/careers/upload';


  /* ========================================
     WORD COUNT
  ======================================== */

  function wordCount(value) {
    var trimmed = (value || '').trim();

    return trimmed
      ? trimmed.split(/\s+/).length
      : 0;
  }


  function validateWordField(field) {
    var min = parseInt(
      field.dataset.wordMin || '0',
      10
    );

    var max = parseInt(
      field.dataset.wordMax || '0',
      10
    );

    var count =
      wordCount(field.value);

    var scope =
      field.form || document;

    var counter =
      scope.querySelector(
        '[data-word-count-for="' +
          field.id +
          '"]'
      );

    var error =
      scope.querySelector(
        '[data-error-for="' +
          field.id +
          '"]'
      );

    if (counter) {
      counter.textContent =
        count +
        (
          count === 1
            ? ' word'
            : ' words'
        );
    }

    field.setCustomValidity('');

    var message = '';

    if (
      min &&
      count < min
    ) {
      var remaining =
        min - count;

      message =
        'Please add at least ' +
        remaining +
        ' more ' +
        (
          remaining === 1
            ? 'word'
            : 'words'
        ) +
        '.';
    }

    else if (
      max &&
      count > max
    ) {
      var excess =
        count - max;

      message =
        'Please remove at least ' +
        excess +
        ' ' +
        (
          excess === 1
            ? 'word'
            : 'words'
        ) +
        '.';
    }

    if (message) {
      field.setCustomValidity(
        message
      );
    }

    if (error) {
      error.textContent =
        message;
    }

    return !message;
  }


  /* ========================================
     FILE VALIDATION
  ======================================== */

  function validateFile(input) {
    input.setCustomValidity('');

    if (
      !input.files ||
      !input.files.length
    ) {
      if (input.required) {
        input.setCustomValidity(
          'Please upload your resume as a PDF.'
        );

        return false;
      }

      return true;
    }


    var file =
      input.files[0];


    var looksLikePdf =
      file.type === 'application/pdf' ||
      /\.pdf$/i.test(file.name);


    if (!looksLikePdf) {
      input.setCustomValidity(
        'Please upload a PDF file.'
      );

      return false;
    }


    if (
      file.size >
      MAX_FILE_BYTES
    ) {
      input.setCustomValidity(
        'The file must be 20 MB or smaller.'
      );

      return false;
    }


    return true;
  }


  function setFileStatus(
    form,
    name,
    message
  ) {
    var status =
      form.querySelector(
        '[data-file-status="' +
          name +
          '"]'
      );

    if (status) {
      status.textContent =
        message || '';
    }
  }


  /* ========================================
     FORM STATUS
  ======================================== */

  function setBusy(
    form,
    busy
  ) {
    var button =
      form.querySelector(
        '[data-submit-button]'
      );

    var label =
      form.querySelector(
        '[data-submit-label]'
      );

    var spinner =
      form.querySelector(
        '[data-submit-spinner]'
      );


    if (!button) {
      return;
    }


    button.disabled =
      busy;


    button.setAttribute(
      'aria-busy',
      busy ? 'true' : 'false'
    );


    if (label) {
      label.textContent =
        busy
          ? 'Submitting application…'
          : (
              button.dataset.defaultLabel ||
              'Submit application'
            );
    }


    if (spinner) {
      spinner.hidden =
        !busy;
    }
  }


  function setStatus(
    form,
    message,
    type
  ) {
    var status =
      form.querySelector(
        '[data-form-status]'
      );


    if (!status) {
      return;
    }


    status.textContent =
      message || '';


    status.classList.remove(
      'career-form__status--error',
      'career-form__status--success'
    );


    if (type) {
      status.classList.add(
        'career-form__status--' +
          type
      );
    }
  }


  /* ========================================
     JSON REQUEST
  ======================================== */

  async function postJson(
    url,
    payload
  ) {
    var response =
      await fetch(
        url,
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',

            'Accept':
              'application/json'
          },

          body:
            JSON.stringify(payload)
        }
      );


    var data = {};


    try {
      data =
        await response.json();
    }

    catch (error) {
      data = {};
    }


    if (
      !response.ok ||
      data.ok === false
    ) {
      var requestError =
        new Error(
          data.message ||
          'The server could not process the request.'
        );


      requestError.details =
        data;


      throw requestError;
    }


    return data;
  }


  /* ========================================
     SUBMISSION ID
  ======================================== */

  function getSubmissionId(form) {
    if (
      form.dataset.submissionId
    ) {
      return (
        form.dataset.submissionId
      );
    }


    var id;


    if (
      window.crypto &&
      crypto.randomUUID
    ) {
      id =
        crypto.randomUUID();
    }

    else {
      id =
        Date.now().toString(36) +
        '-' +
        Math.random()
          .toString(36)
          .slice(2);
    }


    form.dataset.submissionId =
      id;


    return id;
  }


  /* ========================================
     PRIVATE VERCEL BLOB UPLOAD
  ======================================== */

  async function uploadFile(
    file,
    documentType,
    form,
    submissionId
  ) {
    if (!file) {
      return '';
    }


    setFileStatus(
      form,
      documentType,
      'Preparing secure upload…'
    );


    var uploadSession =
      await postJson(
        UPLOAD_ENDPOINT,
        {
          submission_id:
            submissionId,

          document_type:
            documentType,

          content_type:
            'application/pdf',

          file_size:
            file.size
        }
      );


    if (
      !uploadSession.presigned_url ||
      !uploadSession.pathname
    ) {
      throw new Error(
        'The secure document upload could not be prepared.'
      );
    }


    setFileStatus(
      form,
      documentType,
      'Uploading securely…'
    );


    var uploadResponse =
      await fetch(
        uploadSession.presigned_url,
        {
          method: 'PUT',

          headers: {
            'Content-Type':
              'application/pdf'
          },

          body: file
        }
      );


    if (
      !uploadResponse.ok
    ) {
      console.error(
        'Blob upload failed:',
        uploadResponse.status,
        uploadResponse.statusText
      );


      throw new Error(
        documentType === 'resume'
          ? 'Your resume could not be uploaded. Please try again.'
          : 'Your cover letter could not be uploaded. Please try again.'
      );
    }


    var uploadedBlob = {};


    try {
      uploadedBlob =
        await uploadResponse.json();
    }

    catch (error) {
      console.error(
        'Could not read Blob upload response:',
        error
      );


      throw new Error(
        'The document uploaded, but its storage information could not be confirmed.'
      );
    }


    if (
      !uploadedBlob.url
    ) {
      console.error(
        'Unexpected Blob upload response:',
        uploadedBlob
      );


      throw new Error(
        'The document uploaded, but its storage URL could not be confirmed.'
      );
    }


    setFileStatus(
      form,
      documentType,
      file.name +
        ' · Uploaded securely'
    );


    return uploadedBlob.url;
  }


  /* ========================================
     SERIALIZE
  ======================================== */

  function serializeForm(form) {
    var data = {};

    var formData =
      new FormData(form);


    formData.forEach(
      function (
        value,
        key
      ) {
        if (
          value instanceof File
        ) {
          return;
        }


        data[key] =
          value;
      }
    );


    data.recruitment_consent =
      !!form.querySelector(
        '[name="recruitment_consent"]:checked'
      );


    data.future_roles_consent =
      !!form.querySelector(
        '[name="future_roles_consent"]:checked'
      );


    return data;
  }


  /* ========================================
     STEPS
  ======================================== */

  function getSteps(form) {
    return Array.prototype.slice.call(
      form.querySelectorAll(
        '[data-career-step]'
      )
    );
  }


  function getProgressItems(form) {
    return Array.prototype.slice.call(
      form.querySelectorAll(
        '[data-step-progress]'
      )
    );
  }


  function scrollToFormTop(form) {
    var card =
      form.closest(
        '.career-apply__card'
      );


    if (!card) {
      return;
    }


    var top =
      card.getBoundingClientRect().top +
      window.pageYOffset -
      24;


    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });
  }


  function showStep(
    form,
    stepNumber,
    shouldScroll
  ) {
    var steps =
      getSteps(form);


    var progressItems =
      getProgressItems(form);


    var progressBar =
      form.querySelector(
        '[data-step-progress-bar]'
      );


    var mobileCount =
      form.querySelector(
        '[data-step-mobile-count]'
      );


    var mobileTitle =
      form.querySelector(
        '[data-step-mobile-title]'
      );


    var target = null;


    for (
      var i = 0;
      i < steps.length;
      i++
    ) {
      var step =
        steps[i];


      var number =
        parseInt(
          step.dataset.careerStep,
          10
        );


      var active =
        number === stepNumber;


      step.hidden =
        !active;


      step.setAttribute(
        'aria-hidden',
        active
          ? 'false'
          : 'true'
      );


      if (active) {
        target =
          step;
      }
    }


    for (
      var j = 0;
      j < progressItems.length;
      j++
    ) {
      var item =
        progressItems[j];


      var itemNumber =
        parseInt(
          item.dataset.stepProgress,
          10
        );


      item.classList.toggle(
        'is-active',
        itemNumber === stepNumber
      );


      item.classList.toggle(
        'is-complete',
        itemNumber < stepNumber
      );


      if (
        itemNumber === stepNumber
      ) {
        item.setAttribute(
          'aria-current',
          'step'
        );
      }

      else {
        item.removeAttribute(
          'aria-current'
        );
      }
    }


    if (progressBar) {
      progressBar.style.width =
        (
          (stepNumber - 1) /
          3 *
          100
        ) +
        '%';
    }


    if (mobileCount) {
      mobileCount.textContent =
        'Step ' +
        stepNumber +
        ' of 4';
    }


    if (
      mobileTitle &&
      target
    ) {
      mobileTitle.textContent =
        target.dataset.stepTitle ||
        '';
    }


    form.dataset.currentStep =
      String(stepNumber);


    setStatus(
      form,
      ''
    );


    if (shouldScroll) {
      scrollToFormTop(form);
    }


    if (target) {
      window.setTimeout(
        function () {
          var firstFocusable =
            target.querySelector(
              'input:not([type="hidden"]), select, textarea, button'
            );


          if (firstFocusable) {
            firstFocusable.focus({
              preventScroll: true
            });
          }
        },

        shouldScroll
          ? 250
          : 0
      );
    }
  }


  function validateStep(
    form,
    step,
    reportErrors
  ) {
    var valid = true;

    var firstInvalid = null;


    var fields =
      step.querySelectorAll(
        'input, select, textarea'
      );


    for (
      var i = 0;
      i < fields.length;
      i++
    ) {
      var field =
        fields[i];


      if (
        field.matches(
          '[data-word-min], [data-word-max]'
        )
      ) {
        if (
          !validateWordField(field)
        ) {
          valid = false;
        }
      }


      if (
        field.type === 'file'
      ) {
        if (
          !validateFile(field)
        ) {
          valid = false;
        }
      }


      if (
        !field.checkValidity()
      ) {
        valid = false;


        if (!firstInvalid) {
          firstInvalid =
            field;
        }
      }
    }


    if (
      !valid &&
      reportErrors
    ) {
      setStatus(
        form,
        'Please complete the required fields before continuing.',
        'error'
      );


      if (firstInvalid) {
        firstInvalid.reportValidity();


        firstInvalid.focus({
          preventScroll: true
        });
      }
    }


    return valid;
  }


  function validateAllSteps(form) {
    var steps =
      getSteps(form);


    for (
      var i = 0;
      i < steps.length;
      i++
    ) {
      if (
        !validateStep(
          form,
          steps[i],
          false
        )
      ) {
        var invalidStepNumber =
          parseInt(
            steps[i].dataset.careerStep,
            10
          );


        showStep(
          form,
          invalidStepNumber,
          true
        );


        window.setTimeout(
          function () {
            var visibleStep =
              form.querySelector(
                '[data-career-step="' +
                  form.dataset.currentStep +
                  '"]'
              );


            if (visibleStep) {
              validateStep(
                form,
                visibleStep,
                true
              );
            }
          },
          280
        );


        return false;
      }
    }


    return true;
  }


  /* ========================================
     INITIALIZE FORM
  ======================================== */

  function initForm(form) {
    var submitButton =
      form.querySelector(
        '[data-submit-button]'
      );


    if (submitButton) {
      var submitLabel =
        form.querySelector(
          '[data-submit-label]'
        );


      submitButton.dataset.defaultLabel =
        submitLabel
          ? submitLabel.textContent.trim()
          : 'Submit application';
    }


    /* ------------------------------------
       WORD FIELDS
    ------------------------------------ */

    var wordFields =
      form.querySelectorAll(
        '[data-word-min], [data-word-max]'
      );


    for (
      var i = 0;
      i < wordFields.length;
      i++
    ) {
      (function (field) {

        field.addEventListener(
          'input',
          function () {
            validateWordField(
              field
            );
          }
        );


        field.addEventListener(
          'blur',
          function () {
            validateWordField(
              field
            );
          }
        );


        validateWordField(
          field
        );

      })(wordFields[i]);
    }


    /* ------------------------------------
       FILE FIELDS
    ------------------------------------ */

    var fileInputs =
      form.querySelectorAll(
        'input[type="file"]'
      );


    for (
      var j = 0;
      j < fileInputs.length;
      j++
    ) {
      (function (input) {

        input.addEventListener(
          'change',
          function () {

            validateFile(
              input
            );


            if (
              input.files &&
              input.files.length
            ) {
              var file =
                input.files[0];


              setFileStatus(
                form,
                input.name,

                file.name +
                  ' · ' +
                  (
                    file.size /
                    1024 /
                    1024
                  ).toFixed(1) +
                  ' MB'
              );
            }

            else {
              setFileStatus(
                form,
                input.name,
                ''
              );
            }


            if (
              !input.checkValidity()
            ) {
              input.reportValidity();
            }
          }
        );

      })(fileInputs[j]);
    }


    /* ------------------------------------
       NEXT / BACK
    ------------------------------------ */

    form.addEventListener(
      'click',
      function (event) {

        var nextButton =
          event.target.closest(
            '[data-step-next]'
          );


        var backButton =
          event.target.closest(
            '[data-step-back]'
          );


        if (nextButton) {
          var currentStepNumber =
            parseInt(
              form.dataset.currentStep ||
              '1',
              10
            );


          var currentStep =
            form.querySelector(
              '[data-career-step="' +
                currentStepNumber +
                '"]'
            );


          if (
            currentStep &&
            validateStep(
              form,
              currentStep,
              true
            )
          ) {
            showStep(
              form,
              Math.min(
                currentStepNumber + 1,
                4
              ),
              true
            );
          }
        }


        if (backButton) {
          var backFrom =
            parseInt(
              form.dataset.currentStep ||
              '1',
              10
            );


          showStep(
            form,
            Math.max(
              backFrom - 1,
              1
            ),
            true
          );
        }
      }
    );


    showStep(
      form,
      1,
      false
    );


    /* ====================================
       SUBMISSION
    ==================================== */

    form.addEventListener(
      'submit',

      async function (event) {
        event.preventDefault();


        setStatus(
          form,
          ''
        );


        if (
          !validateAllSteps(form)
        ) {
          return;
        }


        var honeypot =
          form.querySelector(
            '[name="_gotcha"]'
          );


        if (
          honeypot &&
          honeypot.value
        ) {
          return;
        }


        setBusy(
          form,
          true
        );


        try {
          var submissionId =
            getSubmissionId(form);


          var resumeInput =
            form.querySelector(
              '[name="resume"]'
            );


          var coverInput =
            form.querySelector(
              '[name="cover_letter"]'
            );


          var resumeBlobUrl = '';

          var coverLetterBlobUrl = '';


          /* ------------------------------
             RESUME
          ------------------------------ */

          if (
            resumeInput &&
            resumeInput.files &&
            resumeInput.files[0]
          ) {
            setStatus(
              form,
              'Securely uploading your resume…'
            );


            resumeBlobUrl =
              await uploadFile(
                resumeInput.files[0],
                'resume',
                form,
                submissionId
              );
          }


          /* ------------------------------
             COVER LETTER
          ------------------------------ */

          if (
            coverInput &&
            coverInput.files &&
            coverInput.files[0]
          ) {
            setStatus(
              form,
              'Securely uploading your cover letter…'
            );


            coverLetterBlobUrl =
              await uploadFile(
                coverInput.files[0],
                'cover_letter',
                form,
                submissionId
              );
          }


          /* ------------------------------
             SAVE APPLICATION
          ------------------------------ */

          setStatus(
            form,
            'Saving your application…'
          );


          var payload =
            serializeForm(form);


          payload.submission_id =
            submissionId;


          payload.resume_blob_url =
            resumeBlobUrl;


          payload.cover_letter_blob_url =
            coverLetterBlobUrl;


          var endpoint =
            form.action ||
            '/apps/careers/apply';


          var result =
            await postJson(
              endpoint,
              payload
            );


          if (
            result.ok === false
          ) {
            throw new Error(
              result.message ||
              'The application could not be submitted.'
            );
          }


          /* ------------------------------
             SUCCESS
          ------------------------------ */

          var card =
            form.closest(
              '.career-apply__card'
            );


          var success =
            card
              ? card.querySelector(
                  '[data-form-success]'
                )
              : null;


          form.hidden =
            true;

          var formHeader =
            card
              ? card.querySelector(
                  '[data-form-header]'
                )
              : null;

          if (formHeader) {
            formHeader.hidden = true;
          }
          
          if (success) {
            success.hidden =
              false;


            success.focus();
          }


          if (
            window.location.hash !==
            '#apply'
          ) {
            history.replaceState(
              null,
              '',
              '#apply'
            );
          }
        }


        catch (error) {
          console.error(
            'Career application submission failed:',
            error
          );


          setStatus(
            form,

            error &&
            error.message
              ? error.message
              : 'We could not submit your application. Please check your connection and try again.',

            'error'
          );


          setBusy(
            form,
            false
          );
        }
      }
    );
  }


  /* ========================================
     START
  ======================================== */

  function init() {
    var forms =
      document.querySelectorAll(
        '[data-career-application-form]'
      );


    for (
      var i = 0;
      i < forms.length;
      i++
    ) {
      initForm(
        forms[i]
      );
    }
  }


  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  }

  else {
    init();
  }

})();